import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, TextField } from 'seagull';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
export const TextChip = (param)=>{
    let { testId, fieldLabel, value, verbPrefix, valueLabel, operator, editable = true, tone, onApply, onRemove, biPrefix, autoOpen = false, texts } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const [draft, setDraft] = useState(value);
    const resetDraft = ()=>setDraft(value);
    return /*#__PURE__*/ _jsx(AiChipShell, {
        testId: testId,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        operator: operator,
        tone: tone,
        interactive: editable,
        valuePrefix: verbPrefix,
        valueLabel: valueLabel !== null && valueLabel !== void 0 ? valueLabel : value !== '' ? value : undefined,
        applyText: texts.apply,
        onOpen: resetDraft,
        onApply: ()=>onApply(draft.trim()),
        onRemove: onRemove,
        children: (param)=>{
            let { apply } = param;
            return /*#__PURE__*/ _jsx(Box, {
                width: 220,
                children: /*#__PURE__*/ _jsx(TextField, {
                    testId: testIds.AiFilterChipTestIds.EditTextField(),
                    bi: {
                        name: "".concat(biPrefix, "_edit")
                    },
                    fullWidth: true,
                    value: draft,
                    placeholder: texts.placeholder,
                    onChange: (event)=>setDraft(event.target.value),
                    inputProps: {
                        onKeyDown: (event)=>{
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                apply();
                            }
                        }
                    },
                    autoFocus: true
                })
            });
        }
    });
};
